import React, { useCallback } from 'react';
import { Box, HStack } from '@chakra-ui/react';
import Link from '@components/atoms/Link';
import dataLayerPush from '@helpers/dataLayerPush';

const FooterNav = ({ footerMenu, locale, ...props }) => {
  const handleNavigate = useCallback((url, title) => {
    dataLayerPush({
      event: `footer_link_click`,
      interaction: {
        click_text: title,
        link_url: url
      }
    });
  }, []);
  return (
    <Box {...props}>
      {footerMenu?.nodes[0].attributes?.items?.data?.length > 0 && (
        <HStack
          as="ul"
          flexDirection={{ base: `column`, lg: `row` }}
          listStyleType="none"
          spacing={{ base: 4, lg: `107px` }}>
          {footerMenu.nodes[0].attributes.items.data.map(
            ({ attributes: primaryItem }) => (
              <Box key={primaryItem.title} as="li">
                <Link
                  href={primaryItem.url}
                  onClick={
                    () => handleNavigate(primaryItem.url, primaryItem.title)
                    // eslint-disable-next-line react/jsx-curly-newline
                  }
                  display="block"
                  fontFamily="heading"
                  fontWeight="bold"
                  fontSize="2xl"
                  lineHeight="1.2"
                  textTransform="uppercase"
                  textDecoration="none"
                  transition="transform .5s cubic-bezier(0.53, 2, 0.63, 0.53)"
                  _hover={{
                    transform: `auto`,
                    scale: `1.1`,
                    textShadow: `0.2rem 0.2rem 0.5rem #053D8F`
                  }}>
                  {primaryItem.title}
                </Link>
              </Box>
            )
          )}
        </HStack>
      )}
    </Box>
  );
};

export default FooterNav;
